import { EAddressType } from '@common/enums/address-type.enum';
import { FormGetAddressIO } from '@common/general-ui/get-address-io/form-get-address-io.component';
import { IGetAddressIOProps } from '@common/general-ui/get-address-io/get-address-io.component';
import { FormInputLoqate } from '@common/general-ui/input-loqate/form-input-loqate.component';
import { IInputLoqateProps } from '@common/general-ui/input-loqate/input-loqate.component';
import React from 'react';

type IProps = {
    addressType: EAddressType;
} & (IGetAddressIOProps | IInputLoqateProps);

export const FormAddressByEnum = ({ addressType, ...rest }: IProps): JSX.Element => {
    switch (addressType) {
        case EAddressType.GETADDRESSIO:
            return <FormGetAddressIO {...rest} />;

        case EAddressType.LOQATE:
            return <FormInputLoqate {...rest} />;

        default:
            return <>Not implemented {addressType}</>;
    }
};
